<template>
    <span></span>
</template>

<script>
export default {
  name: "CurrentUserMixin",
  data() {
    return {
      freeUserLimits: null,
    }
  },
  mounted() {
    this.get_limits();
  },
  methods: {
    async get_limits() {
      // Use cached version if available - this prevents thousands of API calls
      const response = await this.$api.user.get_limits()
      this.freeUserLimits = response;
    },
    getLimitMessage(translationCategory, limit) {
      let subscriptionPrefix = '';
      if (this.user_sub_id === 0) {
        subscriptionPrefix = 'FREE_';
      } else if (this.user_sub_id === 1) {
        subscriptionPrefix = 'LIM_';
      } else if (this.user_sub_id === 2) {
        subscriptionPrefix = 'PRO_';
      } else if (this.user_sub_id === 3) {
        subscriptionPrefix = 'SUP_';
      }

      const limitMessage = this.$t(`${translationCategory}.limit_reached`);

      return limitMessage.replace('{LIMIT}', this.freeUserLimits[subscriptionPrefix + limit]);
    },
  },
  computed: {
    user_sub_id() {
      return this.current_user ? this.current_user.subscription_id : 0;
    },
    current_user () {
      return this.$store.getters['user/get_current_user'];
    },
    current_user_roles () {
      let project_id = this.$store.getters['user/get_current_project_id'];
      let roles = [];
      if(!this.current_user) {
        return []
      }
      let user_roles_for_project = this.current_user.relationships.user_roles.filter(user_role=>{return user_role.project_id == project_id})
      user_roles_for_project.forEach(user_role=>{
          roles.push(user_role.relationships.role.name);
      })
      return roles;
    },
    is_admin ()
    {
      return this.current_user_roles.includes('Admin')
    },
    is_admin_somewhere ()
    {
      // Check if global admin first
      if (this.is_global_admin) {
        return true;
      }

      let roles = [];

      if(!this.current_user) {
        return []
      }

      let user_roles = this.current_user.relationships.user_roles
      user_roles.forEach(user_role=>{
        roles.push(user_role.relationships.role.name);
      })
      return roles.includes('Admin')
    },
    is_manager () {
      return this.current_user_roles.includes('Manager')
    },
    is_trainer () {
      return this.current_user_roles.includes('Trainer')
    },
    /** Admin or Trainer: exempt from sensitive-image blur when project setting is on. */
    is_sensitive_image_blur_exempt () {
      return this.is_admin || this.is_trainer
    },
    /** Same as blur exempt, but for a specific project (e.g. project cards use session project id). */
    is_sensitive_image_blur_exempt_for_project () {
      return (projectId) => {
        if (!this.current_user || !this.current_user.relationships || !this.current_user.relationships.user_roles) {
          return false;
        }
        const pid = Number(projectId);
        const roles = this.current_user.relationships.user_roles
          .filter((ur) => Number(ur.project_id) === pid)
          .map((ur) => ur.relationships && ur.relationships.role && ur.relationships.role.name)
          .filter(Boolean);
        return roles.includes('Admin') || roles.includes('Trainer');
      };
    },
    is_project_owner() {
      if (!this.current_user) {
        return false;
      }
      const projectId = parseInt(sessionStorage.getItem('project_id'), 10);
      if (Number.isNaN(projectId)) {
        return false;
      }
      const projects = this.$store.getters['project/get_items'] || [];
      const project = projects.find((p) => p && p.id === projectId);
      const owner = project && project.relationships && project.relationships.owner;
      return owner && owner.id === this.current_user.id;
    },
    can_manage_labels() {
      return this.is_admin || this.is_manager || this.is_project_owner;
    },
    is_global_admin () {
      if (!this.current_user) {
        return false;
      }
      if (this.current_user.is_superadmin) {
        return true;
      }
      if (this.current_user.email === 'admin@box21.ai') {
        return true;
      }
      const roles = (this.current_user.relationships && this.current_user.relationships.user_roles) || [];
      return roles.some((ur) => {
        if (ur.project_id != null) {
          return false;
        }
        const name = ur.relationships && ur.relationships.role && ur.relationships.role.name;
        return name === 'SuperAdmin';
      });
    },
  }
}
</script>

<style scoped>

</style>